'use client'

import Image from 'next/image'
import { useState } from 'react'

type Props = {
  src?: string
  alt: string
  width: number
  height: number
  className?: string
  loading?: 'lazy' | 'eager'
  title?: string
  priority?: boolean
}

export default function ImageWithFallback({
  src,
  alt,
  width,
  height,
  className,
  title,
  priority = false,
}: Props) {
  const [imgSrc, setImgSrc] = useState(src || `${process.env.NEXT_PUBLIC_CDN_URL}placeholder-car.webp`)

  return (
    <Image
      src={imgSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      title={title}
      priority={priority}
      fetchPriority={priority ? 'high' : 'auto'}
      unoptimized
      onError={() => setImgSrc(`${process.env.NEXT_PUBLIC_CDN_URL}placeholder-car.webp`)}
    />
  )
}